import { PIXEL_API_URL, PIXEL_BATCH_SECRET } from "../constans/roles";

export const PIXEL_ACCEPT = ".csv,.xml,.xls,.xlsx";
export const PIXEL_INITIAL_FORM = {
  campaignId: "",
  creativeId: "",
  pixelColumnName: "",
};

function extractErrorMessage(payload, fallbackMessage) {
  if (!payload) {
    return fallbackMessage;
  }

  if (typeof payload === "string") {
    return payload;
  }

  return payload.message || payload.error || fallbackMessage;
}

function createDownloadName(response) {
  const contentDisposition = response.headers.get("content-disposition") || "";
  const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

  if (fileNameMatch?.[1]) {
    return fileNameMatch[1];
  }

  return "pixels-output";
}

function downloadBlob(blob, fileName) {
  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(objectUrl);
}

export async function submitPixelGeneration({
  file,
  formData,
  setLoading,
  setInfo,
  setInfoType,
}) {
  if (!file) {
    setInfoType("error");
    setInfo("Wybierz plik do przetworzenia.");
    return;
  }

  if (!formData.campaignId || !formData.creativeId || !formData.pixelColumnName) {
    setInfoType("error");
    setInfo("Uzupelnij Campaign ID, Creative ID oraz Pixel Column Name.");
    return;
  }

  const payload = new FormData();
  payload.append("file", file);
  payload.append("campaignId", formData.campaignId);
  payload.append("creativeId", formData.creativeId);
  payload.append("pixelColumnName", formData.pixelColumnName);

  const headers = {
    "x-batch-secret": PIXEL_BATCH_SECRET,
  };

  setLoading(true);
  setInfo("");
  setInfoType("");

  const response = await fetch(`${PIXEL_API_URL}/tracking/generate-batch`, {
    method: "POST",
    headers,
    body: payload,
  });

  setLoading(false);

  if (!response.ok) {
    let errorPayload = null;

    try {
      errorPayload = await response.json();
    } catch (error) {
      errorPayload = null;
    }

    setInfoType("error");
    setInfo(extractErrorMessage(errorPayload, "Nie udalo sie wygenerowac pliku z pixelami."));
    return;
  }

  const blob = await response.blob();
  downloadBlob(blob, createDownloadName(response));
  setInfoType("success");
  setInfo("Plik z pixelami zostal wygenerowany.");
}
